// Zentrale Status-Definitionen — einzige Quelle für Farben & Reihenfolge
// (vorher dreifach dupliziert in App.js, Dashboard.js, MarkerCluster.js)

export const VERTRIEB_STATUS = [
  { value: null,               label: 'Nicht bearbeitet', color: '#3b82f6' },
  { value: 'Geclosed',         label: 'Geclosed',          color: '#16a34a' },
  { value: 'Interesse',        label: 'Interesse',         color: '#eab308' },
  { value: 'Unstimmig',        label: 'Unstimmig',         color: '#f97316' },
  { value: 'Kein Interesse',   label: 'Kein Interesse',    color: '#ef4444' },
  { value: 'Nicht anwesend',   label: 'Nicht anwesend',    color: '#6b7280' },
  // Haus lässt sich nicht bearbeiten (kein Zugang, Klingelanlage defekt, Adresse existiert
  // nicht …) — Endzustand, zählt nicht in die Abschlussquote, wird aber als Ausschluss-Anteil
  // pro Vertriebler ausgewiesen (Dashboard), damit die Nutzung nachvollziehbar bleibt.
  { value: 'Nicht schreibbar', label: 'Nicht schreibbar',  color: '#1f2937' },
];

// Status, die keine verpasste Chance sind → raus aus dem Nenner der Abschlussquote.
// Ihr Anteil wird im Dashboard separat gezeigt, damit die Lücke nicht zum Schönrechnen einlädt.
export const QUOTE_EXCLUDED = ['Nicht anwesend', 'Nicht schreibbar'];

export const STATUS_COLORS = VERTRIEB_STATUS.reduce((acc, s) => {
  acc[s.value] = s.color;
  return acc;
}, {});

export function getColor(status) {
  return STATUS_COLORS[status ?? null] || '#94a3b8';
}
